export enum User {
    GIAN = 'GIAN',
    SOPHIA = 'SOPHIA'
}


export const userName: { [key in User]: string } = {
    [User.GIAN]: 'Gian',
    [User.SOPHIA]: 'Sophia'
}
